import React from 'react';
import {
    Container,
    Row,
    Col,
} from 'reactstrap';
import '../style/SelectedFileOverlay.css';
import { ArchiveFilterBar } from '../components/ArchiveFilterBar';
import { archiveConstants } from '../contstants/archive.contstants';
import { Style } from 'react-style-tag';

export default class ArchiveContent extends React.Component {
    state = {
        files: [],
        isOpen: false,
        display: archiveConstants.GRID,
        filterString: ''

    }
    toggle = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.files !== this.props.files && this.props.files !== undefined) {
            const { files } = this.props;
            this.setState({ files });
        }
    }
    componentDidMount() {
        const { files } = this.props;
        this.setState({
            files
        })
    }
    filterFiles = (str) => {
        this.setState({ filterString: str })
    }
    toggleDisplayType = (dt) => {
        this.setState({ display: dt });
    }
    convertFont = (f) => {
        return f.substring(f.lastIndexOf('/') + 1, f.lastIndexOf('.') + 1).toString()
            .replace(')', '')
            .replace('(', '').replace('.', '').replace('1', '').replace('', '');
    }
    render() {
        const { files, filterString, display } = this.state;
        const { selectedFile, onSelect, type } = this.props;
        return (
            <div>
                <Container className="grid-container display-type">
                    <ArchiveFilterBar
                        toggleDisplayType={this.toggleDisplayType}
                        filterFiles={this.filterFiles}
                        result={files && files.filter((f, i) => {
                            return (this.props.filterType.includes(f.type.substring(f.type.lastIndexOf('/') + 1).toUpperCase()) ||
                                this.props.filterType.includes(f.type.substring(f.type.lastIndexOf('/') + 1).toLowerCase())) && f.name.toLowerCase().includes(filterString.toLowerCase())
                        }).length} />
                </Container>

                <Container className="grid-container">

                    <Row className="grid-item-wrapper" >
                        {files && files.filter((f, i) => {
                            return (this.props.filterType.includes(f.type.substring(f.type.lastIndexOf('/') + 1).toUpperCase()) ||
                                this.props.filterType.includes(f.type.substring(f.type.lastIndexOf('/') + 1).toLowerCase())) &&
                                f.name.toLowerCase().includes(filterString.toLowerCase()) && f
                        }).map((f, i) => {
                            return (
                                <Col key={i} onClick={() => onSelect(f)}
                                    className={`image-slot grid-item ${
                                        selectedFile &&
                                        selectedFile.name === f.name
                                        && 'archive-selected-container'}`}>
                                    <Row className={f.type.includes('png') ? "png-wrapper" : "preview-image-wrapper"}>

                                        {f.type.includes('image') &&
                                            <div> <img
                                                src={f.url}
                                                alt="_blank"
                                                className="preview-image" /></div>
                                        }
                                        {f.type.includes('font') &&
                                            <div>
                                                <p style={{
                                                    fontFamily: this.convertFont(f.name),
                                                    fontSize: '12px'
                                                }}>{this.convertFont(f.name)}</p>
                                                <p style={{
                                                    fontFamily: this.convertFont(f.name),
                                                    fontSize: '14px'
                                                }}>{this.convertFont(f.name)}</p>
                                                <p style={{
                                                    fontFamily: this.convertFont(f.name),
                                                    fontSize: '16px'
                                                }}>{this.convertFont(f.name)}</p>
                                                <Style>{`
                                                @font-face {
                                                    font-family: ${this.convertFont(f.name)};
                                                    src: url('${f.url}');
                                                }
                                                `}</Style>
                                            </div>
                                        }
                                        {f.type.includes('pdf') &&
                                            <div style={{ width: '100%', textAlign: 'center' }}>
                                                <i className="fa fa-file-pdf-o" style={{ fontSize: '7em' }} />
                                            </div>
                                        }
                                    </Row>
                                    <div >
                                        <Row
                                            className='preview-info'>
                                            <h6 >{f.name.substring(f.name.lastIndexOf('/') + 1, 18)}..</h6>

                                            {!f.type.includes('pdf') ? <span className="text-muted info-text">
                                                {Math.round((f.size * 0.001) * 10) / 10}
                                                {" kB   "}
                                            </span> :
                                                f.type
                                            }
                                        </Row>
                                    </div>
                                    {selectedFile &&
                                        selectedFile.name === f.name && <div className={"archive-selected-overlay"}>
                                            <span href="#" className={'archive-selected-icon'} title="image">

                                                <i className="fa fa-check-circle selected-icon"></i>
                                            </span>
                                        </div>}
                                </Col>
                            )
                        })}
                    </Row>
                </Container>
            </div>
        )
    }
}
